import { init } from '@emailjs/browser';
init("user_4totNko6Xrs20EjGdyXMr");

export const keys = { USER_ID: "service_ptb6lts", TEMPLATE_ID: "template_9mf0qqw" }

export default keys